import React from 'react';

export const UserHubsDoBIcon = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      className={className}
      style={style}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.66667 14.6663C2.47778 14.6663 2.31944 14.6025 2.19167 14.4747C2.06389 14.3469 2 14.1886 2 13.9997V10.6663C2 10.2997 2.13056 9.98579 2.39167 9.72468C2.65278 9.46356 2.96667 9.33301 3.33333 9.33301V6.66634C3.33333 6.29967 3.46389 5.98579 3.725 5.72467C3.98611 5.46356 4.3 5.33301 4.66667 5.33301H7.33333V4.36634C7.13333 4.23301 6.97222 4.0719 6.85 3.88301C6.72778 3.69412 6.66667 3.46634 6.66667 3.19967C6.66667 3.03301 6.7 2.86912 6.76667 2.70801C6.83333 2.5469 6.93333 2.39967 7.06667 2.26634L8 1.33301L8.93333 2.26634C9.06667 2.39967 9.16667 2.5469 9.23333 2.70801C9.3 2.86912 9.33333 3.03301 9.33333 3.19967C9.33333 3.46634 9.27222 3.69412 9.15 3.88301C9.02778 4.0719 8.86667 4.23301 8.66667 4.36634V5.33301H11.3333C11.7 5.33301 12.0139 5.46356 12.275 5.72467C12.5361 5.98579 12.6667 6.29967 12.6667 6.66634V9.33301C13.0333 9.33301 13.3472 9.46356 13.6083 9.72468C13.8694 9.98579 14 10.2997 14 10.6663V13.9997C14 14.1886 13.9361 14.3469 13.8083 14.4747C13.6806 14.6025 13.5222 14.6663 13.3333 14.6663H2.66667ZM4.66667 9.33301H11.3333V6.66634H4.66667V9.33301ZM3.33333 13.333H12.6667V10.6663H3.33333V13.333Z" />
    </svg>
  );
};
